import React, { useEffect, useState } from "react";
import Herowithvideo from "../components/Generic/Herowithvideo"; 
import VisionMission from "../components/Aboutus/VisionMission";
//import Team from "../components/Aboutus/Team";
import Seo from "../components/Generic/Seo";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";
import { getByQuery } from "../api/API";
import InViewFade from "../components/Generic/InViewFade";
import LoadingSpinner from "../components/Generic/LoadingSpinner";

const AboutPage = () => {
  const [aboutVideo, setAboutVideo] = useState(null); 
  const [loading, setLoading] = useState(true);

  const seoData = {
    title: "About Wise Community | Our Vision, Mission & TeamAbout WiSE — Women in Semiconductor Ecosystem | Our Story & Mission",
    description:
      "Discover WiSE (Women in Semiconductor Ecosystem): our mission, vision and story. We empower, connect and elevate women from campus to corporate to career in the semiconductor industry through mentorship, community and opportunity.",
    keywords:
      "Women in Semiconductor, WiSE, about WiSE, semiconductor women community, women in tech semiconductors, semiconductor mentorship, women leadership semiconductor, women in STEM semiconductor, diversity in semiconductor, women empowerment semiconductor, semiconductor industry women, WiSE mission",
    pathSlug: "about",
  };

  const aboutTextData = {
    title: "How it started",
    subtitle:
      "Despite the rapid growth of the semiconductor industry, women remain significantly underrepresented across technical and leadership roles. Many face challenges such as: Limited access to mentorship and visible role models Fewer networking opportunities compared to male peers Lack of safe, inclusive platforms to share experiences and learn Gaps in career advancement support, from student to executive levels This underrepresentation not only affects women’s individual growth but also impacts the diversity of ideas, innovation, and leadership in the industry..",
  };

  useEffect(() => {
    async function fetchAboutVideo() {
      try {
        const query = `where[folder.slug]=abouthero&where[mimeType][like]=video/&sort=-createdAt&limit=1`;
        const res = await getByQuery("/media", query);
        if (res?.docs?.length > 0) {
          const video = res.docs[0];
          setAboutVideo({
            videoSrc: video.url || "",
            videoPoster: video.thumbnail?.url || "",
          });
        }
      } catch (error) {
        console.error("Error fetching about video", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAboutVideo();
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center my-5"
        style={{ minHeight: "400px" }}
      >
        <LoadingSpinner size="6rem" />
      </div>
    );
  }

  return (
    <>
      <Seo data={seoData} />
      <GoogleAnalytics page={seoData.pathSlug} title={seoData.title} />

      <InViewFade>
        <Herowithvideo
          {...aboutTextData}

          /* ✅ IMAGE VERSION */
          imageSrc="/assets/images/Events.png" 

          /* ❌ VIDEO CODE COMMENTED OUT
          videoSrc={aboutVideo?.videoSrc || ""}
          videoPoster={aboutVideo?.videoPoster || ""}
          */
        />
      </InViewFade>

     {/* <InViewFade direction="right">
        <Team />
      </InViewFade> */}

      <InViewFade direction="left">
        <VisionMission />
      </InViewFade>
    </>
  );
};

export default AboutPage;
